import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const SceneSafety = ({ onNext, onBack, onDataChange, data }) => {
  const [checklist, setChecklist] = useState(data || {
    hazards: false,
    ppe: false,
    stopBurning: false,
    movePatient: false,
    vitalSigns: false,
    cSpine: false,
    preventHypothermia: false
  });

  const handleCheckboxChange = (key) => {
    const newChecklist = { ...checklist, [key]: !checklist[key] };
    setChecklist(newChecklist);
    if (onDataChange) {
      onDataChange({ scene_safety: newChecklist });
    }
  };

  const safetyItems = [
    { key: 'hazards', label: 'Assess scene for hazards (fire, chemicals, electrical)' },
    { key: 'ppe', label: 'Ensure personal protective equipment (PPE) is used' },
    { key: 'stopBurning', label: 'Stop the burning process on patient' },
    { key: 'movePatient', label: 'Move patient to a safe area' },
    { key: 'vitalSigns', label: "Assess patient's vital signs and consciousness" },
    { key: 'cSpine', label: 'Protect C-spine if trauma suspected' },
    { key: 'preventHypothermia', label: 'Cover patient to prevent hypothermia' }
  ];

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-black py-4">
      <div className="w-full max-w-sm mx-auto px-4">
        <div className="flex flex-col min-h-screen bg-zinc-900 rounded-3xl border-2 border-orange-500/30 shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b-2 border-orange-500/30">
            <Button
              onClick={onBack}
              variant="ghost"
              className="flex items-center gap-2 text-orange-500 text-lg font-bold"
            >
              <ArrowLeft className="w-6 h-6" />
              Back
            </Button>
            <h1 className="text-xl font-black text-orange-500">Scene Safety</h1>
            <div className="w-16" />
          </div>

          {/* Content */}
          <main className="flex-grow overflow-y-auto p-4 bg-black space-y-3">
            {safetyItems.map(item => (
              <label
                key={item.key}
                className="flex items-start p-4 rounded-2xl bg-zinc-900 cursor-pointer transition-all duration-200 hover:bg-zinc-800 border-2 border-orange-500/20"
              >
                <input
                  type="checkbox"
                  checked={checklist[item.key]}
                  onChange={() => handleCheckboxChange(item.key)}
                  className="h-7 w-7 mt-0.5 rounded border-2 border-orange-500 bg-transparent text-orange-500 focus:ring-orange-500"
                />
                <span className="ml-4 text-lg font-semibold text-orange-100 leading-snug">
                  {item.label}
                </span>
              </label>
            ))}
          </main>

          {/* Footer */}
          <div className="p-4 border-t-2 border-orange-500/30 bg-zinc-900">
            <Button
              onClick={onNext}
              className="w-full h-14 bg-orange-500 text-white text-lg font-black rounded-xl hover:bg-orange-600 transition-colors flex items-center justify-center gap-2 shadow-xl"
            >
              Next
              <ArrowRight className="w-6 h-6" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SceneSafety;